export type ServerResponseType = {
  bodyText: string;
  completed: boolean;
  dueDate?: string | null;
};

export type GetDisclosuresResponseType = {
  bodyTextSanitized: {
    __html: string;
  };
  completed: boolean;
  dueDate?: string | null;
};

export enum Disclosures {
  Initial = 'agent_initial_fcra_disclosure',
  FCRAAdverseAction = 'agent_fcra_adverse_action_notice',
  ClueMvrAdverseAction = 'agent_clue_mvr_adverse_action_notice',
  Reports = 'agent_reports_for_insurance_transaction',
  Purchase = 'agent_payment_and_edelivery_notice',
  MilitaryDiscount = 'agent_la_military_discount_notice',
  GoodStudentDiscount = 'agent_good_student_discount_notice',
  CustomerDocuments = 'agent_signature_documents_notice',
  AgentSignatureAffirmation = 'agent_signature_affirmation',
  AgentBindAuthorization = 'agent_bind_authorization',
  AgentTOS = 'agent_tos',
  VehiclePhotos = 'vehicle_photos',
  VehicleSetup = 'vehicle_setup', // Persistence is not required for this disclosure; it exists solely for the frontend.
  ProofOfForeignDriversLicense = 'proof_of_foreign_drivers_license',
}
